import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface FeatureFlag {
  key: string;
  enabled: boolean;
}

export const useFeatureFlags = () => {
  return useQuery({
    queryKey: ["featureFlags"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("feature_flags")
        .select("key, enabled");

      if (error) throw error;

      const flags: Record<string, boolean> = {};
      (data as FeatureFlag[]).forEach((flag) => {
        flags[flag.key] = flag.enabled;
      });

      return flags;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    gcTime: 1000 * 60 * 30, // Keep in cache for 30 minutes
  });
};
